<div fxLayout="column" class="container" 
(keydown)="EnterSubmit($event)">
    <div class="dialog-title">
        <span>Primary Account Password Required</span>
    </div>

    <div fxLayout="column" class="back-white">
        <div class="dialog">
            The password for the primary account is needed prior to purchase.
        </div>

        <div class="dialog">
            <label for="pass">Password:</label><input [(ngModel)]="password" type="password">
        </div>

        <div *ngIf="passwordWait" class="spinner-wrapper">
            <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
        </div>
    
        <div class="buttons" fxLayout="row" fxLayoutAlign="space-around">
            
            <button
            class="button secondary-button"
            (click)="onCancel()">
                Cancel
            </button>
    
            <button 
            class="button primary-button"
            (click)="onSubmit()"> 
                Submit
            </button>
        </div>  
    </div>

    
</div>


  